import properties from '../assets/gitesStruct.json';
import gallery from '../assets/gallery.json';
import content from './content';

export const gites = Object.values(properties);
export const gitesById = properties;
export const gitePath = gite => '/hebergement-a-marie-galante/' + gite.url_folder;
export const giteName = gite => gite.presentation.nom;
export const money = value => new Intl.NumberFormat(content.locale, { style: 'currency', currency: content.pricing.currency, maximumFractionDigits: 0 }).format(value);
export const nightlyRate = (gite, people = content.pricing.defaultGuests) => gite.tarif + Math.max(0, people - content.pricing.includedGuests) * content.pricing.extraGuestPerNight;
export const stayPrice = (gite, nights, people) => nightlyRate(gite, people) * nights;
export const photos = gite => gallery[gite.initial].map(item => ({ ...item, original: '/' + item.original, thumbnail: '/' + item.thumbnail }));
export const seaView = gite => gite.important.some(item => item.type === 'vue_mer');
export const maxGuests = Math.max(...gites.map(gite => gite.maxclient));

// Date-only UTC arithmetic avoids a lost night when daylight saving time changes.
export function nightsBetween(start, end) {
  if (!start || !end) return 0;
  const result = (Date.parse(end + 'T00:00:00Z') - Date.parse(start + 'T00:00:00Z')) / 86400000;
  return Number.isFinite(result) && result > 0 ? result : 0;
}
export function today() {
  const date = new Date();
  return [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');
}
export const frenchDate = value => value ? value.split('-').reverse().join('/') : '';
